// @flow
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  getRowIdOfGivenRowForEstimateCC,
  getDimensionLevelConfigArrayFromMetricRowForEstimateCC,
  getIfAnyOtherRowBesidesTheGivenRowIsBeingEditedForEstimateCC,
  getIfGivenRowIsANewlyAddedRowForEstimateCC,
} from '@components/committed-capacity/utils';
import { useEstimateVersion } from '@src/custom-hooks/useEstimateVersion';

import { toastError } from '../../presentational/notifications/utils';
import { ResetFormButton } from '../../presentational/buttons/ResetFormButton';
import { useDeleteCommittedCapacityConfigurationMutation } from '../../../service-definitions/estimates';

const getIfCurrentDimensionRowIsTheLoneChildOfParentMetric = (metricRow) => {
  return getDimensionLevelConfigArrayFromMetricRowForEstimateCC(metricRow).length === 1;
};

export const CommittedCapacityDimensionsLineItemDeleteContainerForEstimateCC = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  dimensionIndex,
  metricIndex,
  dimensionArrayHelpers,
  metricArrayHelpers,
}) => {
  const { estimateId } = useParams();
  const estimateVersion = useEstimateVersion();
  const [deleteFunc] = useDeleteCommittedCapacityConfigurationMutation();

  // Delete should always be enabled - only case when it will be disabled is if any other row is being edited
  const shouldDeleteButtonBeDisabled = getIfAnyOtherRowBesidesTheGivenRowIsBeingEditedForEstimateCC(
    configuredMetrics,
    dimensionRow
  );

  return (
    <ResetFormButton
      disabled={shouldDeleteButtonBeDisabled}
      onClick={async () => {
        if (getIfGivenRowIsANewlyAddedRowForEstimateCC(dimensionRow)) {
          // If it is a newly added row, then simply delete it from UI
          // Besides that, if it was the only item added for a new metric, then, deleting this one should delete the parent metric too
          dimensionArrayHelpers.remove(dimensionIndex);
          if (getIfCurrentDimensionRowIsTheLoneChildOfParentMetric(metricRow)) {
            metricArrayHelpers.remove(metricIndex);
          }
          return;
        }
        const payload = {
          estimate_version: estimateVersion,
        };
        const { error } = await deleteFunc({
          estimateId,
          payload,
          committedCapacityId: getRowIdOfGivenRowForEstimateCC(dimensionRow),
        });

        if (error) {
          toastError(
            error,
            'There was an error in deleting the config, please contact #cloud-commitment-estimator channel!'
          );
        } else {
          dimensionArrayHelpers.remove(dimensionIndex);
        }
      }}
    />
  );
};
